import { GCashButton } from '@src/components/Button';
import { TransactionDetailsPage } from '@src/pages/EntityDetailsPage';
import { useWLOrderFormSelector } from '@talos/kyoko';
import { useLocation, useNavigate } from 'react-router-dom';

export function CashTransactionResultPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const rootRoute = location.pathname.split('/')[1];

  const transaction = useWLOrderFormSelector(state => state.swap.meta.balanceTransaction);

  const handleBack = () => {
    const goBackRoute = rootRoute ? `/${rootRoute}` : '/';
    navigate(goBackRoute, { replace: true });
  };

  if (!transaction) {
    // TODO(robertz): improve by adding loading that shows after 1 second, then show a 404 after 5 seconds?
    return null;
  }

  return (
    <div
      className="flex h-full flex-1 flex-col items-center gap-8 p-4 text-center text-sm"
      data-testid="cash-transaction-result"
    >
      <TransactionDetailsPage transaction={transaction} navigatedFromPlacement />

      {/* Back button */}
      <div className="mt-auto w-full">
        <GCashButton
          onClick={handleBack}
          size="lg"
          className="w-full"
          variant="primary"
          data-testid="back-to-dashboard"
        >
          Back to Dashboard
        </GCashButton>
      </div>
    </div>
  );
}
